<template>
    <pm-custom-dialog v-if="visible" v-model="visible" id="pm-video-dialog">
        <div slot="close-btn" @click="close" style="position: absolute; width: 28px; height: 28px; background: #fff; line-height: 22px; text-align: center; top: 32px; right: 12px; border: 2px solid #ddd; border-radius: 50%;" class="main-dialog--close">
            <span style="font-weight: 600;"><v-icon style="font-size: 16px;">close</v-icon></span>
        </div>

        <div style="position: relative; background: #fff; border-radius: 8px; text-align: center; margin: 0; padding: 0; height: auto;">
            <video controls controlsList="nodownload" allowfullscreen id="dialogVideoPlayer" @ended="close" @error="onVideoError" ref="video" playsinline muted autoplay style="display: block; margin: 0; padding: 0; width: 100%;">
                <source @error="onVideoError" playsinline v-if="supportsHLS" :src="videoSrc + '.m3u8'" type="application/x-mpegURL">
                <source @error="onVideoError" playsinline :src="videoSrc + '.mp4'" type="video/mp4">
            </video></div>
    </pm-custom-dialog>
</template>

<style>
    #pm-video-dialog .pm-custom-dialog-content {
        background: none;
        box-shadow: none;
    }
    #pm-video-dialog video {
        width: 100%;
        border-radius: 8px;
    }
</style>

<script>
import PmCustomDialog from "./base-dialog.vue";
import { logVideoPlayThrough } from "@/utils/analytics/usage.ts";
import { supportsHLS } from "../../utils/device/media-support";
export default {
    components: {
        PmCustomDialog
    },
    props: {
        dialogData: {
            type: Object,
            default: () => ({}),
        }
    },
    data: () => ({
        visible: false,
        videoStarted: false,
        warningShown: 0,
        videoSrc: "",
    }),
    created() {

    },
    computed: {
        supportsHLS() {
            return supportsHLS();
        },
    },
    methods: {
        show() {
            this.videoSrc = this.dialogData.src;
            this.visible = true;

            window.Tracker.logEvent({
                event_name: "player-dialog-open",
                event_category: "video",
                event_label: this.videoSrc,
            });
        },
        onVideoError() {
            this.close();
        },
        close() {
            logVideoPlayThrough(document.getElementById("dialogVideoPlayer"));
            this.visible = false;
            this.$emit('close');
        },
    }
}
</script>
